import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiService from '../../Services/apiServices';

const initialState = {
  outletId: '',
  items: [],
  status: 'idle',
  actionStatus: 'idle',
  error: null
};

export const fetchOutletPlans = createAsyncThunk('plans/fetchOutletPlans', async (outletId, thunkAPI) => {
  try {
    const response = await apiService.get(`/barbellOSOutlet/plans/${outletId}/all`);
    return {
      outletId,
      plans: Array.isArray(response.data?.data) ? response.data.data : []
    };
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.response?.data?.detail || 'Failed to fetch plans');
  }
});

export const createOutletPlan = createAsyncThunk('plans/createOutletPlan', async (planPayload, thunkAPI) => {
  try {
    await apiService.post('/barbellOSOutlet/plans/add', planPayload);
    await thunkAPI.dispatch(fetchOutletPlans(planPayload.outlet_id));
    return true;
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.response?.data?.detail || 'Failed to create plan');
  }
});

export const toggleOutletPlanActivation = createAsyncThunk(
  'plans/toggleOutletPlanActivation',
  async ({ outletPlanId, activate, outletId }, thunkAPI) => {
    try {
      const suffix = activate ? 'activate' : 'deactivate';
      await apiService.put(`/barbellOSOutlet/plans/${outletPlanId}/${suffix}`);
      await thunkAPI.dispatch(fetchOutletPlans(outletId));
      return true;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data?.detail || 'Failed to update plan');
    }
  }
);

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOutletPlans.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchOutletPlans.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.outletId = action.payload.outletId;
        state.items = action.payload.plans;
      })
      .addCase(fetchOutletPlans.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch plans';
      })
      .addCase(createOutletPlan.pending, (state) => {
        state.actionStatus = 'loading';
        state.error = null;
      })
      .addCase(createOutletPlan.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(createOutletPlan.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload || 'Failed to create plan';
      })
      .addCase(toggleOutletPlanActivation.pending, (state) => {
        state.actionStatus = 'loading';
        state.error = null;
      })
      .addCase(toggleOutletPlanActivation.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(toggleOutletPlanActivation.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload || 'Failed to update plan';
      });
  }
});

export default plansSlice.reducer;
